import React, { useEffect } from 'react';
import TrackingStudent from './TrackingStudent';
import useSettings from '../hooks/useSettings';
import { useStudentsActions, useStudentsState } from '../contexts/StudentsContext';

const TrackingContainer = () => {
  const { students } = useStudentsState();
  const { getAllStudents } = useStudentsActions();
  useEffect(() => {
    getAllStudents();
  }, []);
  useEffect(() => {
    const interval = setInterval(getAllStudents, 5000);
    return () => {
      clearInterval(interval);
    };
  }, [getAllStudents]);

  const { yellowTime, redTime } = useSettings();

  return (
    <div className="columns-5">
      {students
        .filter(({ checkInTime }) => {
          return checkInTime != null;
        })
        .map(({ firstName, lastName, checkInTime, sessionTime }) => (
          <TrackingStudent
            key={`trackingstudent-${firstName}-${lastName}`}
            firstName={firstName}
            lastName={lastName}
            checkInTime={checkInTime as number}
            sessionTime={sessionTime}
            yellowTime={parseInt(yellowTime || '15')}
            redTime={parseInt(redTime || '5')}
          />
        ))}
    </div>
  );
};

export default TrackingContainer;
